import { defineComponent as _defineComponent } from 'vue'
import BaseHttpService from 'JS/services/BaseHttpService';
import bugsnagClient from '../../global/bugsnag';
import ProductsCarousel from './ProductsCarousel.vue';
import VIntersectionObserver from 'Src/js/components/VIntersectionObserver.vue';
import { computed, ref, watch } from 'vue';
import { ILazyCarousel, ProductCarousel } from 'src/js/types/Carousel';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyProductCarousel',
  props: {
    carousel: null
  },
  setup(__props: any) {

const props = __props as {
	carousel: ILazyCarousel;
}



const carouselRes = ref<ProductCarousel | null>(null);
const loading = ref(false);

const hasCarousel = computed(() => !!carouselRes.value?.products?.length);

const { isMobile } = useBreakpoints();
const intersectionObserverOptions = computed((): IntersectionObserverInit => {
	const rootMargin = isMobile.value
		? '300px' // start loading a bit sooner on mobile
		: '100px';

	return {
		root: null,
		rootMargin,
	};
});

const httpService = new BaseHttpService();

async function loadCarouselData() {
	loading.value = true;

	try {
		carouselRes.value = await httpService.get(props.carousel.carouselUrl, { headers: { 'Cache-Control': 'no-cache' } });
	} catch (err) {
		bugsnagClient.notify(err);
		// eslint-disable-next-line no-console
		console.warn(err);
	}

	loading.value = false;
}

watch(() => props.carousel.carouselUrl, _newUrl => {
	loadCarouselData();
});

return { __sfc: true,props, carouselRes, loading, hasCarousel, isMobile, intersectionObserverOptions, httpService, loadCarouselData, ProductsCarousel, VIntersectionObserver }
}

})